import { render, staticRenderFns } from "./PsConfigurationLink.vue?vue&type=template&id=130d02cd&scoped=true&"
import script from "./PsConfigurationLink.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationLink.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationLink.vue?vue&type=style&index=0&id=130d02cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d02cd",
  null
  
)

export default component.exports